import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';

interface IPageCr0048 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Cr0048Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass) {
    const vm: IPageCr0048 = this;

    vm.multiOccurrenceOptions = {
        colonnesVisibles: [
            { nom: 'rfiann', largeur: 115 },
            { nom: 'rfimntpossec', largeur: 150 },
            { nom: 'rfinumentdon', largeur: 150 },
            { nom: 'rfinumseq', largeur: 150 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('rfiann'),
            new FormulaireItem('rfimntpossec'),
            new FormulaireItem('rfinumentdon')
        ], { largeurDefaut: 33 }),
        fonctions: {
            rechercheCollapsable: false
        }
    };
}
